<template>
  <h1>USER DOCUMENTS</h1>
</template>

<script>
export default {};
</script>
